/**
 * ============================================================
 *  CONFIGURAÇÃO DO SITE Dr. Pipe
 * ============================================================
 *  Edite este arquivo para alterar TODO o conteúdo do site.
 *  Depois de editar, gere um novo build (yarn build) e envie
 *  a pasta /build para a sua hospedagem via FTP.
 * ============================================================
 */

export const siteConfig = {
  // ---------- IDENTIDADE VISUAL ----------
  brand: {
    name: "Dr. Pipe",
    tagline: "Desentupidora",
    // Para trocar o logo:
    // 1. Coloque seu arquivo em /public/images/logo.png
    // 2. Troque o valor abaixo para "/images/logo.png"
    // Deixe vazio ("") para usar o logo tipográfico com ícone
    logoImage: "/images/logo.png",
    logoImageFooter: "/images/logo-rodape.png"
  },

  // ---------- CONTATO ----------
  contact: {
    phone: "(13)99695-5454",
    phoneRaw: "+5513996955454",
    whatsapp: "(13)99695-5454",
    whatsappRaw: "5513996955454", // apenas números, com DDI+DDD
    whatsappMessage: "Olá! Vim pelo site e gostaria de um orçamento.",
    email: "contato@drpipe.com.br",
    address: "Praia Grande/SP",
    workingHours: "Atendemos todos os dias",
    serviceAreas: [
      "Praia Grande",
      "São Vicente",
      "Mongaguá",
      "Itanhaém",
      "Peruíbe",
      "Santos",
      "Cubatão",
    ],
  },

  // ---------- HOME ----------
  home: {
    hero: {
      eyebrow: "Segunda à Sexta, 8h às 20h. Sábados, 8h às 18h.",
      title: "Desentupimento profissional, sem sujeira e sem quebrar nada.",
      subtitle:
        "Equipe especializada com equipamentos modernos para resolver qualquer entupimento em minutos. Atendemos residências, condomínios e empresas.",
      heroImage: "/images/hero.jpg",
      ctaPrimary: "Falar no WhatsApp",
      ctaSecondary: "Ver serviços",
    },
    trustBar: [
      { label: "Serviço", value: "Ágil" },
      { label: "Orçamento", value: "Grátis" },
      { label: "Garantia", value: "90 dias" },
      { label: "Chegada", value: "Rápida" },
    ],
    whyUs: [
      {
        title: "Resposta em até 30 minutos",
        desc: "Equipes distribuídas pela cidade chegam rapidamente em casos de emergência.",
      },
      {
        title: "Equipamento profissional",
        desc: "Máquinas rotativas, hidrojateamento e câmera de inspeção para diagnóstico preciso.",
      },
      {
        title: "Preço justo e transparente",
        desc: "Orçamento sem compromisso. Você só paga depois que o problema é resolvido.",
      },
      {
        title: "Sem sujeira e sem quebrar",
        desc: "Técnica limpa que preserva a sua tubulação, pisos e revestimentos.",
      },
    ],
    testimonials: [
      {
        name: "Mariana Silva",
        role: "Moradora — (Praia Grande/SP)",
        text: "Ligaram de volta em 2 minutos e em meia hora o técnico estava aqui. Resolveram o ralo entupido da cozinha sem quebrar nada.",
      },
      {
        name: "Ricardo Tavares",
        role: "Gerente — Restaurante Italiano (São Vicente/SP)",
        text: "Já é a terceira vez que chamo para a caixa de gordura. Pontuais, limpos e profissionais. Parceiros de longa data.",
      },
      {
        name: "Condomínio Vila Nova",
        role: "Síndico — Edifício Residencial (Mongagua/SP)",
        text: "Hidrojateamento no prumada geral do esgoto. Trabalho impecável, sem transtorno aos moradores.",
      },
    ],
  },

  // ---------- SOBRE ----------
  about: {
    eyebrow: "Sobre a Dr. Pipe",
    title: "Mais de uma década desentupindo com respeito ao seu tempo.",
    intro:
      "Somos uma equipe especializada em desentupimento e limpeza de tubulações. Nosso compromisso é tratar a sua casa ou empresa com o mesmo cuidado que teríamos com a nossa. Sem surpresas no orçamento e sem bagunça.",
    image: "/images/about.jpg",
    values: [
      {
        title: "Transparência",
        desc: "Orçamento claro antes do serviço. Sem taxas escondidas.",
      },
      {
        title: "Agilidade",
        desc: "Equipes prontas 24h para emergências, 7 dias por semana.",
      },
      {
        title: "Respeito",
        desc: "Tratamos sua casa com o cuidado e a limpeza que ela merece.",
      },
      {
        title: "Garantia",
        desc: "90 dias de garantia em todos os serviços executados.",
      },
    ],
  },

  // ---------- SERVIÇOS ----------
  services: [
    {
      title: "Desentupimento de Pia",
      desc: "Remoção de gordura e resíduos em pias de cozinha e banheiro com equipamento rotativo, sem quebrar o sifão.",
      icon: "Droplets",
    },
    {
      title: "Desentupimento de Ralo",
      desc: "Limpeza de ralos de banheiro, área de serviço e quintal. Eliminamos odores e retorno de água.",
      icon: "CircleDot",
    },
    {
      title: "Desentupimento de Vaso Sanitário",
      desc: "Desobstrução imediata com equipamento apropriado. Sem risco de vazamento ou quebra do vaso.",
      icon: "Toilet",
    },
    {
      title: "Desentupimento de Esgoto",
      desc: "Desobstrução de tubulações de esgoto predial e residencial, com câmera para localização exata.",
      icon: "Waves",
    },
    {
      title: "Desentupimento de Condutores",
      desc: "Desentupimento de condutores é o serviço de limpeza e desobstrução de tubulações verticais e calhas que conduzem água pluvial.",
      icon: "Settings",
    },
    {
      title: "Caixa de Gordura",
      desc: "Limpeza e desobstrução de caixas de gordura residenciais e comerciais (restaurantes, padarias, cozinhas industriais).",
      icon: "Container",
    },
    {
      title: "Desentupimento Predial",
      desc: "Desentupimento predial é o serviço especializado na remoção de obstruções em tubulações de edifícios, como esgotos, ralos e colunas coletivas.",
      icon: "Gauge",
    },
    {
      title: "Industria e Comércio",
      desc: "Desentupimento para indústria e comércio é o serviço de remoção de obstruções em tubulações, redes de esgoto e sistemas de drenagem em ambientes comerciais e industriais.",
      icon: "Truck",
    },
  ],

  // ---------- CONTATO / FAQ ----------
  faq: [
    {
      q: "Quanto tempo demora para o técnico chegar?",
      a: "Na maioria das regiões, nossa equipe chega em até 30 minutos após o seu contato, 24h por dia.",
    },
    {
      q: "O orçamento é gratuito?",
      a: "Sim. Enviamos um técnico gratuitamente para avaliar o problema e dar o orçamento. Você decide se autoriza o serviço.",
    },
    {
      q: "Vocês atendem em finais de semana e feriados?",
      a: "Sim, funcionamos 7 dias por semana, incluindo feriados, sem taxa extra.",
    },
    {
      q: "Vocês quebram piso ou parede?",
      a: "Não. Utilizamos técnicas que preservam a estrutura. Só quebramos em situações extremas e sempre com autorização do cliente.",
    },
    {
      q: "Qual a garantia do serviço?",
      a: "Oferecemos 90 dias de garantia em todos os nossos serviços de desentupimento.",
    },
  ],

  // ---------- FOOTER ----------
  footer: {
    description:
      "Dr. Pipe — Desentupidora profissional. Atendimento rápido, sem sujeira e com garantia.",
    copyright: `© ${new Date().getFullYear()} Dr. Pipe. Todos os direitos reservados.`,
  },
};

export default siteConfig;
